'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  container: {
    borderLeftColor: 'inherit',
    borderRightColor: 'inherit',
    flexShrink: 0
  },
  header: {
    color: _colors2.default.secondaryText,
    fontSize: '14px',
    fontWeight: 'bolder',
    lineHeight: '22px',
    marginBottom: '5px'
  },
  avatar: {
    position: 'absolute',
    left: '-48px',
    top: '0'
  },
  badge: {
    marginLeft: '4px'
  }
};
module.exports = exports.default;